export default __webpack_public_path__ + "static/media/SABADO.2f9d0420.jpeg";